// Side effect imports
import './prototype';

import { createDuration } from './create';
import { isDuration } from './constructor';
import {
    getSetRelativeTimeRounding,
    getSetRelativeTimeThreshold,
} from './humanize';

export {
    createDuration,
    isDuration,
    getSetRelativeTimeRounding,
    getSetRelativeTimeThreshold,
};



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/duration/duration.js
// module id = 553
// module chunks = 0